var _circle, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkModeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.83,
    cy: 7.634,
    r: 6.83,
    fill: "#1E2833"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.24,
    cy: 5.491,
    rx: 5.759,
    ry: 5.491,
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNi44MzAzNiIgY3k9IjcuNjM0MDciIHI9IjYuODMwMzYiIGZpbGw9IiMxRTI4MzMiLz4KPGVsbGlwc2UgY3g9IjkuMjQwMzciIGN5PSI1LjQ5MTA3IiByeD0iNS43NTg5MyIgcnk9IjUuNDkxMDciIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgDarkModeIcon as ReactComponent };